// extracted by mini-css-extract-plugin
export default {"ConsultConatiner":"Consult_ConsultConatiner__K62-8","card":"Consult_card__Yj1D-","company":"Consult_company__NaxpX"};